import { CurrencyCode } from '@/helpers/currency';
import { formatCurrencyAmount, normalizeCurrencyCode } from './formatAmounts';
import type { ILevelConfig } from './types';

const getLevelBonusAmount = ({ reward }: ILevelConfig) =>
  reward.kind === 'bonus' ? reward.amount : (reward.bonusAmount ?? 0);

export const getTotalBonusLabel = (
  levelsConfig: ILevelConfig[],
  currencyCode?: string
) => {
  const total = levelsConfig.reduce(
    (sum, level) => sum + getLevelBonusAmount(level),
    0
  );

  return total
    ? formatCurrencyAmount(
        total,
        normalizeCurrencyCode(currencyCode) ?? CurrencyCode.USD
      )
    : undefined;
};
